import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
const Login = () => import('../views/login/login.vue')
const CasLogin = () => import('../views/login/caslogin.vue')
const SelectRole = () => import('../views/login/selectrole.vue')
const Index = () => import('../views/index.vue')
const MyCourse = () => import('../views/mycourse/mycourse.vue')//我的课程
const CourseDetail = () => import('../views/mycourse/coursedetail.vue')//课程详情
const ProDetail = () => import('../views/mycourse/prodetail.vue')//专题详情
const HomePage = () => import('../views/homepage/homePage.vue')//首页
const MyCenter = () => import('../views/mycenter/mycenter.vue')//个人中心


Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/caslogin',
      name: 'caslogin',
      component: CasLogin
    },
    {
      path: '/selectrole',
      name: 'selectrole',
      component: SelectRole
    },
    {//课程详情
      path: '/coursedetail',
      name: 'coursedetail',
      component: CourseDetail
    },
    {//专题详情
      path: '/prodetail',
      name: 'prodetail',
      component: ProDetail
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      // redirect: '/homepage',
      children: [
        {//主页
          path: '/homepage',
          name: 'homepage',
          component: HomePage
        },
        {//我的课程界面
          path: '/mycourse',
          name: 'mycourse',
          component: MyCourse
        },
        {//个人中心
          path: '/mycenter',
          name: 'mycenter',
          component: MyCenter
        },

      ]

    },

  ]
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js